// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"83":"ce464280","370":"12f7d7b3"}[chunkId] + ".js";
};